import React, {Fragment, useEffect, useState} from 'react';
import moment from "moment";
import CUFormService from "../../../../services/CUFormService";
import FormService from "../../../../services/FormsService";
import Color from "color";

const TemplateCUBParticipationDemo = (props) => {

    const [entity, setEntity] = useState({name:'', email:'', phone:'', cp:'', city: '', address:'', address2:'', stamp:''})
    const cuFormService = new CUFormService();
    const formService = new FormService();
    const [imgBase64, setImgBase64] = useState();
    const [annexes, setAnnexes] = useState();

    useEffect(()=>{
        setEntity(cuFormService.getEntityInfo())
        setAnnexes(formService.getEntityAnnexes())
    }, [])

    useEffect(()=>{

    }, [annexes])

    useEffect( ()=>{
           // (entity && entity.stamp && entity.stamp != '')?ImgLinktoDataURL("/storage/images/entities/"+entity.id+"/"+entity.stamp):null;
    },[entity])

    const ImgLinktoDataURL =(url)=>{
        let xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                setImgBase64(reader.result)
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>ARTICLE 6 - Participation</h3>
            </div>
            <p>
                Les participations ci-dessous pourront être exigées à l'occasion d'un  permis de construire ou d'une décision de non opposition à une déclaration préalable.
                Si tel est le cas, elles seront mentionnées dans l'arrêté de permis ou dans un arrêté pris dans les deux mois suivant la date du permis tacite ou de la décision de non opposition à une déclaration préalable
            </p>
            <p className={"ue-font-weight-7"}><strong>Participations exigibles sans procédure de délibération préalable : </strong> </p>
            {
                (annexes?.a6_txt1 && annexes?.a6_txt1 !=='')
                    ? <p style={{"paddingLeft":"20px", 'whiteSpace':'pre-line'}}  dangerouslySetInnerHTML={{__html:annexes.a6_txt1.replace(/(?:\r\n|\r|\n)/g, '<br />')}}/>
                    :<p style={{"paddingLeft":"20px"}}>- Participation pour équipements publics exceptionnels (articles L. 332-6-1-2° c) et L. 332-8 du code de l’urbanisme) </p>
            }
            <p className={"ue-font-weight-7"}><strong>Participations prélablement instaurées par délibération : </strong></p>
            {
                (annexes?.a6_txt2 && annexes?.a6_txt2 !=='')
                    ? <p style={{"paddingLeft":"20px", 'whiteSpace':'pre-line'}}  dangerouslySetInnerHTML={{__html:annexes.a6_txt2.replace(/(?:\r\n|\r|\n)/g, '<br />')}}/>
                    :<p style={{"paddingLeft":"20px"}}>- Participation pour voiries et réseaux (articles L. 332-6-1-2° d), L. 332-11-1 et L. 332-11-2 du code de l’urbanisme)</p>
            }
            {(props.formtype === 'cub') ?
                <>
                    <div className="ue-section ue-section-title" style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                        <span>AVIS</span>
                    </div>
                    <br/>
                    <br/>
                    <table className={"ue-table-simple ue-mb-3"}>
                        <thead style={{'fontWeight': 'bold', 'color': "#000000"}}>
                        <tr className={"text-left"}>
                            <th>Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr className={"text-left"}>
                            <td className={"eu-text-optionnel"}>&Agrave; completer</td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                </>
                : null
            }
            <br/>
        </div>

    );
};

export default TemplateCUBParticipationDemo;
